import React, { useState } from "react";
import { Box, Button } from "@mui/material";

import PendingRegularization from "../pendingRegularization";
import HistoryRegularization from "../HistoryRegularization";
import { setIsReviewRegularizationScreen } from "../../../store/reducers/regularizationSlice";
import { useDispatch } from "react-redux";
const ReviewRegularization = () => {
  const [selectedTab, setSelectedTab] = useState("active");
  const dispatch = useDispatch();
  dispatch(setIsReviewRegularizationScreen(true));
  const onTabChange = (tabId) => {
    setSelectedTab(tabId);
  };
  const tabs = [
    {
      id: "active",
      name: "Active",
      content: (
        <PendingRegularization
          shoulShowApproveReject={true}
          shouldGetManagerRecords={false}
        />
      ),
    },
    {
      id: "closed",
      name: "Closed",
      content: <HistoryRegularization shouldGetManagerRecords={false} />,
    },
  ];
  const selectedTabContent = tabs.find(
    (tab) => tab.id === selectedTab
  )?.content;

  return (
    <>
      <Box className="flex justify-center" sx={{ mb: 3, pt: 6 }}>
        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          {tabs.map((tab) => (
            <Button
              key={tab}
              variant={selectedTab === tab?.id ? "contained" : "text"}
              onClick={() => onTabChange(tab?.id)}
              sx={{
                textTransform: "none",
                minWidth: 80,
                backgroundColor:
                  selectedTab === tab?.id ? "#2196F3" : "transparent",
                color: selectedTab === tab?.id ? "white" : "#666",
                border: "1px solid #2196F3",
              }}
            >
              {tab?.name}
            </Button>
          ))}
        </Box>
      </Box>
      {selectedTabContent}
    </>
  );
};

export default ReviewRegularization;
